import { useEffect, useRef, useState } from "react";

export default function TruncatedText({ text, className = "" }) {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setIsOverflowing(el.scrollWidth > el.clientWidth + 1);
  }, [text]);

  if (!text) return <span className="text-slate-300">—</span>;

  return (
    <div className="group/tt relative min-w-0">
      <span ref={ref} className={`block truncate ${className}`}>
        {text}
      </span>

      {isOverflowing && (
        <div
          role="tooltip"
          className="pointer-events-none absolute left-0 top-full z-30 mt-1.5 hidden max-w-[240px] rounded-lg bg-slate-900 px-2.5 py-1.5 text-[11px] leading-snug text-white shadow-lg group-hover/tt:block"
        >
          {text}
          <div className="absolute -top-1 left-3 h-2 w-2 rotate-45 bg-slate-900" />
        </div>
      )}
    </div>
  );
}